<template>
  <specialoffer-check-view :cellcolor="`#F3F7FF`"></specialoffer-check-view>
</template>

<script>
import specialofferCheckView from '@/views/workbench/workCheckView/specialofferCheckView/specialofferCheckView'
export default {
  name: 'specialofferLimitCheckView',
  components: {
    specialofferCheckView
  },
  provide () {
    return {
      pageTitle: '特价限制审批',
      type: 1
    }
  }
}
</script>

<style scoped>

</style>
